import { render, staticRenderFns } from "./TeacherSettings.vue?vue&type=template&id=12b7aeed"
import script from "./TeacherSettings.vue?vue&type=script&lang=js"
export * from "./TeacherSettings.vue?vue&type=script&lang=js"
import style0 from "./TeacherSettings.vue?vue&type=style&index=0&id=12b7aeed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports